export const gtmId = "GTM-PMF7HLQ";
export const gtmIdDev = "GTM-5BGKPZVD";

export const mapboxConfig = {
    lineColour: "000000",
    markerColour: "757575",
    width: 400,
    height: 400,
    padding: 50,
    departureLabel: "d",
    arrivalLabel: "a",
    accessToken: "pk.eyJ1Ijoiam9lYWRjb2NrIiwiYSI6ImNsZDM1YzU0bzBmZWMzc29hNGE0c3hvbjYifQ.yIR--emn3ctKrGxbGRMRBQ",
    showLogo: false,
};

export const recaptcha = {
    site: "6LeY76kkAAAAAJN_pPQo_649CfbSqXqzPB2uJd14",
};

/**
 * @param {boolean} isPoweredBy - Whether the site is in powered-by mode
 * @returns {string[]} List of restricted paths/URLs or empty array
 */
export const getRestrictedLinks = (isPoweredBy) => {
    if (isPoweredBy) {
        return [
            "/ambassador",
            "/blog",
            "/careers",
            "/fly/about-us",
            "/fly/destinations",
            "/fly/industry-specialisms",
            "/fly/shy-lifestyle",
            "/fly/contact-us",
            "/fly/movida",
            "/fly/events-private-jet-charter",
            "https://bit.ly/SHY-Aviation-Brochure",
        ];
    } else {
        return [];
    }
};

/**
 * @param {Object} deal - Deal object (stage)
 * @returns {boolean}
 */
export const isDealPreAvinode = (deal) => {
    return deal.stage === "Request a quote" || deal.stage === "Know Your Customer";
};
